import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import OnsiteSignaturePad from './OnsiteSignaturePad';

// Signing popup (IGFEMS-585): full screen on tablet/phone, large dialog on desktop.
// The drawing stays here as a draft — Done hands it to the form, Cancel/✕ throws it away.
// The pad keeps a fixed 5:2 shape (OnsiteSignaturePad); these only cap how tall it may get.
const MIN_PAD = 160;
// Desktop dialog: capped so the dialog stays compact.
const dialogMaxHeight = () => Math.min(Math.max(window.innerHeight - 200, MIN_PAD), 480);
// Matches fullscreen="lg-down" (Bootstrap lg breakpoint = 992px).
const isFullscreen = () => window.innerWidth < 992;

const OnsiteSignatureDialog = ({ show, onHide, onSave, signerName }) => {
  const padRef  = useRef(null);
  const bodyRef = useRef(null);
  const [draft,  setDraft]  = useState('');
  const [ready,  setReady]  = useState(false);
  const [maxHeight, setMaxHeight] = useState(dialogMaxHeight);

  // Mount the pad after the open animation, once the body has its final size.
  // Full screen: the body stretches between header and footer, so the pad may use all of it.
  const handleEntered = () => {
    const body = bodyRef.current;
    if (isFullscreen() && body) {
      const { paddingTop, paddingBottom } = window.getComputedStyle(body);
      setMaxHeight(Math.max(body.clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom), MIN_PAD));
    } else {
      setMaxHeight(dialogMaxHeight());
    }
    setReady(true);
  };
  const handleExited  = () => { setReady(false); setDraft(''); };

  const handleDone = () => {
    onSave(draft);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      onEntered={handleEntered}
      onExited={handleExited}
      fullscreen="lg-down"
      size="xl"
      centered
      className="onsite-sig-dialog"
      aria-labelledby="onsite-sig-dialog-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="onsite-sig-dialog-title" className="onsite-sig-dialog__title">
          Sign here{signerName ? ` — ${signerName}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body ref={bodyRef}>
        {ready && <OnsiteSignaturePad ref={padRef} onChange={setDraft} maxHeight={maxHeight} />}
      </Modal.Body>
      <Modal.Footer className="onsite-sig-dialog__footer">
        <button type="button" className="onsite-sig-dialog__clear" onClick={() => padRef.current?.clear()} disabled={!draft}>
          <i className="fa-solid fa-eraser" aria-hidden="true" /> Clear
        </button>
        <div className="onsite-sig-dialog__actions">
          <button type="button" className="onsite-review__back" onClick={onHide}>Cancel</button>
          <button type="button" className="onsite-form-footer__btn onsite-form-footer__btn--ready" onClick={handleDone} disabled={!draft}>
            <i className="fa-solid fa-check" aria-hidden="true" /> Done
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OnsiteSignatureDialog;
